module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }, [_c('strong', [_vm._v("CONTENTS")])])]), _c('a', {
    attrs: {
      "id": "page_iv"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/s.jpg"
    }
  })])]), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _c('a', {
    attrs: {
      "href": "#/005_Foreword#fm-1"
    }
  }, [_c('em', [_vm._v("Foreword")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/006_Introduction#fm-2"
    }
  }, [_c('em', [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/007_Acknowledgments#fm-3"
    }
  }, [_c('em', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Part01#pt-1"
    }
  }, [_vm._v("I"), _c('br'), _vm._v("CHICAGO JEWS AND THE SECULAR CITY: BUILDERS, MOVERS, SHAKERS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#ch-1"
    }
  }, [_vm._v("Meites’ "), _c('em', [_vm._v("History of the Jews of Chicago")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Chapter02#ch-2"
    }
  }, [_vm._v("Who Was Lazarus Silverman?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter03#ch-3"
    }
  }, [_vm._v("The University of Chicago Centennial")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter04#ch-4"
    }
  }, [_vm._v("World’s Columbian Exposition: Jews on the Midway")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter05#ch-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Julius Rosenwald and the Museum of Science and Industry")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter06#ch-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Century of Progress: Jewish Day Pageant")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Part02#pt-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II"), _c('br'), _vm._v("CHICAGO JEWS AND ANTI-SEMITISM: TRAGEDY ABROAD, CHALLENGES AT HOME")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter07#ch-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Adolf Kraus: Efforts to Help Russian Jews")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter08#ch-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Return of Russian Refugees Prevented")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter09#ch-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Blood Libel: Prejudice on the South Side")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter10#ch-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ambijan: Autonomous Jewish Region of the USSR")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter11#ch-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kristallnacht Haunts Chicago")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Chapter12#ch-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Robert Adler Papers: Refugee Affidavits")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Part03#pt-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III"), _c('br'), _vm._v("CHICAGO JEWS AND ZIONISM: LOCAL IDEALISTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter13#ch-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reverend William Blackstone: Methodist Minister")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/024_Chapter14#ch-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rabbi Bernhard Felsenthal: Pioneer Zionist")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/025_Chapter15#ch-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Leon Zolotkoff: Chicagoan at the First Zionist Congress")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/026_Chapter16#ch-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Julius Rosenwald Meets Aaron Aaronsohn")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/027_Chapter17#ch-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Zionist Convention in Chicago")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/028_Chapter18#ch-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Memoir: Camp Avodah, Summer of 1946")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/029_Chapter19#ch-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Memoir: Israel Independence Celebration")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/030_Part04#pt-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV"), _c('br'), _vm._v("CHICAGO JEWS AND ZIONISM: RENOWNED VISITORS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/031_Chapter20#ch-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shmarya Levin")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/032_Chapter21#ch-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nachum Sokolow")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/033_Chapter22#ch-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Einstein and Weizmann: A Zionist Odd Couple")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/034_Chapter23#ch-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chaim Nachman Bialik: Hebrew Poet")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/035_Chapter24#ch-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Clarence Darrow and Stephen S. Wise Debate Zionism")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/036_Chapter25#ch-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peter Bergson, the Irgun and Chicago")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/037_Chapter26#ch-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ben Hecht Pageant I: We Will Never Die")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/038_Chapter27#ch-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ben Hecht Pageant II: A Flag is Born")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/039_Part05#pt-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V"), _c('br'), _vm._v("CHICAGO JEWS AND THE ARTS: THE PAGE AND THE STAGE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/040_Chapter28#ch-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rosa Sonnenschein: Journalist, Feminist, Zionist")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/041_Chapter29#ch-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sol Bloom, The Music Man")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/042_Chapter30#ch-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Carl Sandburg’s Letter to Jacob Loeb")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/043_Chapter31#ch-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Edna Ferber: Novelist and Playwright")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/044_Chapter32#ch-32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Maxwell Bodenheim: Doomed Poet")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/045_Chapter33#ch-33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Meyer Levin: Compulsion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/046_Part06#pt-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI"), _c('br'), _vm._v("CHICAGO JEWS ON BOTH SIDES OF THE LAW: COLORFUL CHARACTERS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/047_Chapter34#ch-34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dora Feldman McDonald: Sex, Politics and Murder")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/048_Chapter35#ch-35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Davey Miller: The Referee’s Scrapbook")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/049_Chapter36#ch-36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ben Reitman: His Unorthodox Life")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/050_Chapter37#ch-37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Samuel “Nails” Morton: 20th Century Golem")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/051_Chapter38#ch-38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Al “Wallpaper” Wolff: G-Man and Untouchable")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/052_Chapter39#ch-39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kingfish Levinsky: Fighter Could Take a Punch")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/053_Chapter40#ch-40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Moe Berg: “The Catcher Was a Spy”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm1"
  }, [_c('em', [_vm._v("Index")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/054_Photographs#page_178",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Photographs")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ecb6352","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/004_Contents.vue
// module id = 69
// module chunks = 0